import React, { useState } from "react";
import "./QuickActions.css";

const actions = [
  "What is Sukriti ?",
  "What are the perils covered in Samriddhi?",
  "What crops can I grow in Telangana?",
];
interface QuickActionsProps {
  handleActionClick: (action: string) => void;
}
const QuickActions: React.FC<QuickActionsProps> = ({handleActionClick}) => {
  const [selectedAction, setSelectedAction] = useState<string | null>(null);

  const handleClick = (action: string) => {
    setSelectedAction(action);
    handleActionClick(action);
  };


  return (
    <div className="flex justify-center space-x-2 p-4">
      {actions.map((action) => (
        <button key={action} className="action-btn"  onClick={() => handleClick(action)}
          style={{
            display: selectedAction && selectedAction !== action ? "none" : "inline-block",
          }}>
          {action}
        </button>
      ))}
    </div>
  );
};

export default QuickActions;